var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "container", attrs: { fluid: "" } },
        [
          _c(_vm.novoUsuario, {
            tag: "component",
            attrs: { btnRegisterClicado: _vm.btnRegistrarClicado }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }